import { QueryClient } from "@tanstack/react-query";

/**
 * Instance unique de react-query, extraite de `App.tsx` pour être joignable
 * hors composant.
 *
 * Pourquoi : au changement de salle, le cache doit être vidé. Tant que
 * l'instance vivait dans `App.tsx`, `userStore.switchGym` ne pouvait pas
 * l'atteindre et les données de la salle A restaient affichées sous la salle B
 * (clés de requête sans `gym_id`).
 */
/**
 * refetchOnWindowFocus est désactivé globalement : dans l'app Capacitor,
 * chaque retour de background déclenche un focus — avec staleTime 0 par
 * défaut, TOUTES les requêtes montées repartaient et les écrans faisant
 * `if (isLoading) return <Spinner/>` démontaient leurs enfants (perte des
 * formulaires en cours de saisie). Les écrans qui ont besoin de fraîcheur
 * continue utilisent déjà refetchInterval.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: 1,
    },
  },
});
